import { DeterminantRow } from "./determinant-row";

export class DynamicValidationRow extends DeterminantRow {
  public validationMessage: string;
}
